var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseButton',{staticClass:"button-round",attrs:{"buttonClass":_vm.buttonClass,"disabled":_vm.prefixLimitReached},on:{"click":_vm.toggle}},[_c('BaseIcon',{attrs:{"icon":_vm.icon}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }